import { CloseIcon } from "../../../../../assets/icons";
import "./index.scss";
export interface CarouselFilter {
  type: string;
  label: string;
}
interface ActiveFilterTagProps {
  filter: CarouselFilter;
  onRemove?: (filter: CarouselFilter) => void;
}

const ActiveFilterTag = ({ filter, onRemove }: ActiveFilterTagProps) => {
  return (
    <div className="active-filter-tag d-inline-flex align-items-center">
      <button
        type="button"
        className="button-close"
        aria-label="Remover filtro"
        onClick={() => onRemove?.(filter)}
      >
        <span>{filter.label}</span>

        <CloseIcon />
      </button>
    </div>
  );
};

export default ActiveFilterTag;
